import React from 'react';

import {FormattedMessage, injectIntl} from 'react-intl';
import {faPlusCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class ServiceAreaDistancePoints extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      distancePoints: props.formData,
    };

    this.addDistancePoint = this.addDistancePoint.bind(this);
    this.removeDistancePoint = this.removeDistancePoint.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      distancePoints: nextProps.formData
    });
  }

  onChange(index, fieldName) {
    return (event) => {
      const newDistancePoints = this.state.distancePoints;
      newDistancePoints[index][fieldName] = event.target.value;

      this.setState({
        distancePoints: newDistancePoints
      }, () => this.props.onChange(this.state.distancePoints));
    };
  }

  onCoordinateChange(index, fieldName) {
    return (event) => {
      const newDistancePoints = this.state.distancePoints;
      newDistancePoints[index]['coordinates'][fieldName] = event.target.value;

      this.setState({
        distancePoints: newDistancePoints
      }, () => this.props.onChange(this.state.distancePoints));
    };
  }

  addDistancePoint() {
    this.setState({
      distancePoints: [
        ...this.state.distancePoints,
        {
          name: '',
          radius: '',
          distancePricingRadius: '',
          coordinates: {
            lat: '',
            lon: '',
          },
        }
      ]
    }, () => this.props.onChange(this.state.distancePoints));
  }

  removeDistancePoint(index) {
    const newDistancePoints = this.state.distancePoints;
    newDistancePoints.splice(index, 1);
    this.setState({
      distancePoints: newDistancePoints
    }, () => this.props.onChange(this.state.distancePoints));
  }
  
  render() {
    return (
      <div>
        <legend>
          <FormattedMessage id={'distance.points.form.field.legend'}/>
        </legend>

        {this.state.distancePoints.map((distancePoint, index) => {
          
          return (
            <div key={index} className="marketplace-form__delivery-preferences">
              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.distance.points.field.name.label'}/>
                    </label>
                    <input className="form-control" placeholder=""
                           type="text"  value={distancePoint.name}
                           onChange={this.onChange(index,"name")}/>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.distance.points.field.radius.label'}/>
                    </label>
                    <input className="form-control" placeholder=""
                           type="text"  value={distancePoint.radius}
                           onChange={this.onChange(index,"radius")}/>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.distance.points.field.distance.pricing.radius.label'}/>
                    </label>
                    <div className="m-b-1">
                      <input className="form-control" placeholder=""
                             type="text"  value={distancePoint.distancePricingRadius}
                             onChange={this.onChange(index,"distancePricingRadius")}/>
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'service.area.form.field.distance.points.field.distance.pricing.radius.help'}/>
                    </p>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.distance.points.field.coordinates.lat.label'}/>
                    </label>
                    <input className="form-control" placeholder=""
                           type="text"  value={distancePoint.coordinates.lat}
                           onChange={this.onCoordinateChange(index,"lat")}/>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'service.area.form.field.distance.points.field.coordinates.lon.label'}/>
                    </label>
                    <input className="form-control" placeholder=""
                           type="text"  value={distancePoint.coordinates.lon}
                           onChange={this.onCoordinateChange(index,"lon")}/>
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button onClick={() => this.removeDistancePoint(index)} className="btn btn-default btn-small">
                  <FormattedMessage id={'service.area.form.field.distance.points.remove'}/>
                </button>
              </div>
            </div>
          );
        })}

        <div className="marketplace-form__delivery-preferences-add m-b-1" onClick={this.addDistancePoint}>
          <small>
            <FontAwesomeIcon icon={faPlusCircle} /> <FormattedMessage id={'service.area.form.field.distance.points.add'}/>
          </small>
        </div>
      </div>
    );
  }
}

export default injectIntl(ServiceAreaDistancePoints);